module.exports = __webpack_public_path__ + "static/media/SavePrice.adbd9138.svg";